import {
    ASSET_REVENUE_REPORT_DOWNLOAD_START,
    ASSET_REVENUE_REPORT_DOWNLOAD_STOP,
    ASSET_REVENUE_REPORT_SUCCESS,
    FETCH_IDEAL_DAYS_FAILED,
    FETCH_IDEAL_DAYS_START,
    FETCH_IDEAL_DAYS_SUCCESS,
    FETCH_LEASING_CALCULATION_SUCCESS,
    FETCH_LEASING_COST_FAILED,
    FETCH_LEASING_COST_START,
    FETCH_LEASING_COST_SUCCESS,
    FETCH_LEASING_REVENUE_FAILED,
    FETCH_LEASING_REVENUE_START,
    FETCH_LEASING_REVENUE_SUCCESS,
    FETCH_LEASING_STATUS_FAILED,
    FETCH_LEASING_STATUS_START,
    FETCH_LEASING_STATUS_SUCCESS,
    FETCH_LEASING_SUCCESS,
    LEASING_COST_CALCULATION,
    REMOVE_IMAGE_SUCCESS,
    UPDATE_LEASING_DESCRIPTION_FAIL,
    UPDATE_LEASING_DESCRIPTION_SUCCESS,
    UPLOAD_IMAGE_SUCCESS,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from 'antd';
import {objectToQuery} from "../../util/Api";
import moment from "moment/moment";
import {store} from "../../NextApp";
import Swal from 'sweetalert2';

export const getLeasables = (filterData) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/leasing`, filterData);
            dispatch(fetchSuccess());
            // console.log(response.data);
            dispatch(getLeasablesSuccess({data: response.data}));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            dispatch(getLeasablesFailed());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getLeasablesSuccess = ({data}) => {
    return {
        type: FETCH_LEASING_SUCCESS,
        data,
    }
};

export const getLeasingCalculationsSuccess = ({data}) => {
    console.log(data)
    return {
        type: FETCH_LEASING_CALCULATION_SUCCESS,
        data,
    }
};


export const getLeasablesFailed = () => {
    return {
        type: FETCH_LEASING_SUCCESS,
        data: [],
    }
};

export const updateLeasingDescription = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/leasing/info-update`, payload);
            dispatch(fetchSuccess());
            dispatch(updateLeasingDescriptionSuccess({data: response.data}));
            message.success("Leasing Information updated!")
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const updateLeasingDescriptionSuccess = ({data}) => {
    return {
        type: UPDATE_LEASING_DESCRIPTION_SUCCESS,
        data,
    }
};

export const updateLeasingDescriptionFail = () => {
    return {
        type: UPDATE_LEASING_DESCRIPTION_FAIL,
        data: null,
    }
};

export const uploadImage = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let formData = new FormData();
            formData.append("file", payload.file);
            formData.append("assetId", payload.assetId);
            const response = await axios.post(`/leasing/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            dispatch(fetchSuccess());
            if (response.data)
                dispatch(uploadImageSuccess({data: response.data}));
            else
                message.error('Not Uploaded!');
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const uploadImageSuccess = ({data}) => {
    return {
        type: UPLOAD_IMAGE_SUCCESS,
        data,
    }
};

export const removeImage = (assetId, docId) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.delete(`/leasing/remove-image/${assetId}/${docId}`);
            if (response.data) {
                dispatch(fetchSuccess());
                dispatch(uploadImageRemoveSuccess({data: response.data}));
            } else {
                dispatch(fetchError("Unable to remove!"));
                // message.error('Unable to remove!');
            }
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const uploadImageRemoveSuccess = ({data}) => {
    return {
        type: REMOVE_IMAGE_SUCCESS,
        data,
    }
};

export const getLeasingStatus = (assetId) => {
    return async (dispatch) => {
        dispatch(statusAccessStart({id: assetId}));
        try {
            const response = await axios.get(`/contract/status/${assetId}`);
            if (response.data)
                dispatch(statusAccessSuccess({id: assetId, data: response.data}));
            else
                dispatch(statusAccessFailed({id: assetId}));
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            // dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const statusAccessSuccess = ({id, data}) => {
    return {
        type: FETCH_LEASING_STATUS_SUCCESS,
        data,
        id,
    }
};

export const statusAccessFailed = ({id}) => {
    return {
        type: FETCH_LEASING_STATUS_FAILED,
        id,
    }
};

export const statusAccessStart = ({id}) => {
    return {
        type: FETCH_LEASING_STATUS_START,
        id,
    }
};

export const getLeasingCost = (assetId) => {
    return async (dispatch) => {
        dispatch(leasingCostStart({id: assetId}));
        try {
            const response = await axios.get(`/common/asset-cost/${assetId}`);
            if (response.data)
                dispatch(leasingCostSuccess({id: assetId, data: response.data}));
            else
                dispatch(leasingCostFailed({id: assetId}));
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            // dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const leasingCostSuccess = ({id, data}) => {
    return {
        type: FETCH_LEASING_COST_SUCCESS,
        data,
        id,
    }
};

export const leasingCostFailed = ({id}) => {
    return {
        type: FETCH_LEASING_COST_FAILED,
        id,
    }
};

export const leasingCostStart = ({id}) => {
    return {
        type: FETCH_LEASING_COST_START,
        id,
    }
};

export const getLeasingRevenue = (assetId) => {
    return async (dispatch) => {
        dispatch(leasingRevenueStart({id: assetId}));
        try {
            const response = await axios.get(`/contract/revenue/${assetId.toString()}`);
            if (response.data) {
                dispatch(leasingRevenueSuccess({id: assetId, data: response.data}));
            } else
                dispatch(leasingRevenueFailed({id: assetId}));
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            // dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const leasingRevenueSuccess = ({id, data}) => {
    return {
        type: FETCH_LEASING_REVENUE_SUCCESS,
        data,
        id,
    }
};

export const leasingRevenueFailed = ({id}) => {
    return {
        type: FETCH_LEASING_REVENUE_FAILED,
        id,
    }
};

export const leasingRevenueStart = ({id}) => {
    return {
        type: FETCH_LEASING_REVENUE_START,
        id,
    }
};

export const getLeasingIdealDays = (assetId) => {
    return async (dispatch) => {
        dispatch(leasingIdealDaysStart({id: assetId}));
        try {
            const response = await axios.get(`/contract/ideal/${assetId.toString()}`);
            if (typeof response.data === 'number') {
                dispatch(leasingIdealDaysSuccess({id: assetId, data: response.data}));
            } else
                dispatch(leasingIdealDaysFailed({id: assetId}));
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            // dispatch(updateLeasingDescriptionFail());
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const leasingIdealDaysSuccess = ({id, data}) => {
    return {
        type: FETCH_IDEAL_DAYS_SUCCESS,
        data,
        id,
    }
};

export const leasingIdealDaysFailed = ({id}) => {
    return {
        type: FETCH_IDEAL_DAYS_FAILED,
        id,
    }
};

export const leasingIdealDaysStart = ({id}) => {
    return {
        type: FETCH_IDEAL_DAYS_START,
        id,
    }
};

export const getAssetRevenueReportData = (reqObj) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/contract/revenue-report`, reqObj);
            console.log(response.data);
            dispatch(fetchSuccess());
            dispatch(assetRevenueReportDataSuccess(response.data || []));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const assetRevenueReportDataSuccess = ({data}) => {
    return {
        type: ASSET_REVENUE_REPORT_SUCCESS,
        data,
    }
};

export const downloadStart = (isStart, data) => {
    return {
        type: isStart ? ASSET_REVENUE_REPORT_DOWNLOAD_START : ASSET_REVENUE_REPORT_DOWNLOAD_STOP,
        data
    }
};

export const processDataForDownload = (reportData) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/leasing/report-email`, reportData);
            const responseMessage = response.data || 'Report will be emailed!';
            message.success(responseMessage);
            Swal.fire(
                'Processing!',
                responseMessage,
                'success'
            )
            dispatch(fetchSuccess());
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            dispatch(fetchError(error));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const processDataForDownload_deprected = (reportData) => {
    return async (dispatch) => {
        dispatch(downloadStart(true, []));
        try {
            const prom = reportData.map(async data => {
                const id = data._id ? data._id : data.id || '';
                if (!id)
                    throw Error(`Invalid Data, try later!`);
                const statusResponse = await axios.get(`/contract/status/${id}`);
                if (statusResponse.data)
                    data['status'] = statusResponse.data.status;
                const costResponse = await axios.get(`/common/asset-cost/${id}`);
                if (costResponse.data)
                    data['cost'] = costResponse.data;
                const revenueResponse = await axios.get(`/contract/revenue/${id}`);
                if (revenueResponse.data)
                    data['revenue'] = revenueResponse.data;
                const idealDayResponse = await axios.get(`/contract/ideal/${id.toString()}`);
                if (typeof idealDayResponse.data === 'number')
                    data['ideal'] = idealDayResponse.data;
                return data;
            });

            const docs = await Promise.all(prom);
            const promDocs = docs.map(async item => {
                let status = '';
                switch (item.status) {
                    case 'OPEN':
                        status = 'Available';
                        break;
                    case 'CLOSED':
                        status = 'Under Lease';
                        break;
                    case 'EXPIRED' :
                        status = 'Expired';
                        break;
                    case 'BLOCKED' :
                        status = 'Blocked';
                        break;
                    default:
                        status = '';
                        break;
                }
                return {
                    'AssetCode': item.assetCode,
                    'AssetType': item.assetType && item.assetType.name ? item.assetType.name : '',
                    'SubType': item.subType && item.subType.name ? item.subType.name : '',
                    'Model': item.model && item.model.name ? item.model.name : '',
                    'Status': status,
                    'OwnershipCost': (item.cost && item.cost > 0) ? item.cost.toFixed(2) : 0.00,
                    'Revenue': (item.revenue && item.revenue > 0) ? item.revenue.toFixed(2) : 0.00,
                    'IdealDays': item.ideal,
                };
            });
            const finalDoc = await Promise.all(promDocs);
            dispatch(downloadStart(false, finalDoc));
        } catch (error) {
            // dispatch(fetchError(error.response.data.message));
            dispatch(downloadStart(false, []));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getLeasablesCostingsBreakup = (filterData) => {
    return async (dispatch) => {
        dispatch(fetchStart());

    }
}

export const getLeasablesCostings = (filterData) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const {leasing} = store.getState();
            const response = await axios.get(`/leasing?${objectToQuery(filterData)}`);
            let data = response.data;
            data = await formatCostingWithData(data, filterData.pageSize);

            const monthlyData = await breakUpData([].concat(...data));

            switch (filterData.type) {
                case 'm':
                    dispatch(getLeasingCalculationsSuccess({data: monthlyData}));
                    dispatch(fetchSuccess());
                    break;
                case 'q':
                    const qtr = await breakUpDataQuarterly(monthlyData, 'q');
                    dispatch(getLeasingCalculationsSuccess({data: [].concat(...qtr)}));
                    dispatch(fetchSuccess());
                    break;
                case 'h':
                    const half = await breakUpDataQuarterly(monthlyData, 'h');
                    dispatch(getLeasingCalculationsSuccess({data: [].concat(...half)}));
                    dispatch(fetchSuccess());
                    break;
                case 'a':
                    const year = await breakUpDataQuarterly(monthlyData, 'a');
                    dispatch(getLeasingCalculationsSuccess({data: [].concat(...year)}));
                    dispatch(fetchSuccess());
                    break;
                default:
                    dispatch(getLeasingCalculationsSuccess({data: monthlyData}));
                    dispatch(fetchSuccess());
                    break;
            }
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            dispatch(getLeasablesFailed());
            console.log("Error****:", error.response.data.message);
        }
    }
};

const breakUpData = (leaseData) => {
    const tempData = [...leaseData];
    return new Promise((done) => {
        const monthlyData = tempData.map((data, index) => {
            const revenue = (data.revenue || []).reduce((sum, item) => sum + item.amount || 0, 0);
            const maintenance = (data.maintenance || []).reduce((sum, item) => sum + item.cost || 0, 0);
            const idealDays = (data.idealDays || []).reduce((sum, item) => sum + item.days || 0, 0);
            const status = data.status || 'Open';
            const ebit = Number(revenue) - Number(maintenance);
            const market = data.marketValue || 0;
            const roi = Number(ebit) / Number(market);
            const opsDay = moment().diff(data.leasingDate ? data.leasingDate : moment(), 'days');
            const annRoi = Number(roi / (opsDay / 365));
            return {
                key: index,
                id: data._id,
                breakupName: 'Month',
                breakupFieldName: data.month,
                month: data.month,
                assetCode: data.assetCode,
                assetType: data.assetType && data.assetType.name ? data.assetType.name : '',
                assetSubType: data.subType && data.subType.name ? data.subType.name : '',
                assetModel: data.model && data.model.name ? data.model.name : '',
                status,
                leasingDate: data.leasingDate ? moment(data.leasingDate).format('DD/MM/YYYY') : '-',
                marketValue: data.marketValue ? Number(data.marketValue).toFixed(2) : 0.00,
                maintenanceCost: maintenance,
                revenue,
                idealDays,
                opsDay,
                ebit,
                roi,
                annRoi,
                unRecovered: Number(market - ebit),
            };
        });
        done(monthlyData);
    })
};

const formatCostingWithData = (data, pageSize) => {
    return new Promise(async (done, reject) => {
        const item = [];
        if (data && data.length > 0) {
            for (let i = 0; i < pageSize; i++) {
                const doc = data[i];
                if (doc) {
                    const costData = await axios.get(`/contract/cost/${doc._id}`);
                    const {maintenance, idealDays, revenue, status, ...others} = costData.data;

                    let keys = (maintenance && maintenance.data) ? Object.keys(maintenance.data) : [];
                    keys = keys.concat((revenue && revenue.data) ? Object.keys(revenue.data) : []);
                    keys = keys.concat((idealDays && idealDays.data) ? Object.keys(idealDays.data) : []);
                    keys = [...new Set(keys)];
                    let datas = {};
                    data[i] = keys.map(key => {
                        datas = {month: key, ...doc, ...others};
                        datas['maintenance'] = maintenance && maintenance.data && maintenance.data[key] || null;
                        datas['revenue'] = revenue && revenue.data && revenue.data[key] || null;
                        datas['idealDays'] = idealDays && idealDays.data && idealDays.data[key] || null;
                        datas['status'] = status && status.status || null;
                        return datas;
                    });
                }
            }
            done(data)
        }
    })
};

export const getLeasingCostCalculation = ({asset}) => {
    return async (dispatch) => {
        //dispatch(fetchStart());
        try {
            const response = await axios.get(`/contract/cost/${asset}`);
            dispatch(fetchSuccess());
            dispatch(leasingCostCalculationSuccess(response.data || []));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const leasingCostCalculationSuccess = (data) => {
    return {
        type: LEASING_COST_CALCULATION,
        data,
    }
};

const breakUpDataQuarterly = (monthlyData, breakUp) => {
    const tempData = [...monthlyData];
    return new Promise((done) => {
        const years = [...new Set(tempData.map(td => td.month.split('-')[0]))];
        const qtrlyData = years.map(year => {
            const qtrData = [];
            let breakupName = '';
            if (breakUp === 'q') {
                breakupName = 'Quarterly';
                let q = [[`${year}-01`, `${year}-02`, `${year}-03`], [`${year}-04`, `${year}-05`, `${year}-06`], [`${year}-07`, `${year}-08`, `${year}-09`], [`${year}-10`, `${year}-11`, `${year}-12`]];
                qtrData[0] = tempData.filter(data => q[0].includes(data.month));
                qtrData[1] = tempData.filter(data => q[1].includes(data.month));
                qtrData[2] = tempData.filter(data => q[2].includes(data.month));
                qtrData[3] = tempData.filter(data => q[3].includes(data.month));
            } else if (breakUp === 'h') {
                breakupName = 'HalfYearly';
                let h = [[`${year}-01`, `${year}-02`, `${year}-03`, `${year}-04`, `${year}-05`, `${year}-06`],
                    [`${year}-07`, `${year}-08`, `${year}-09`, `${year}-10`, `${year}-11`, `${year}-12`]];
                qtrData[0] = tempData.filter(data => h[0].includes(data.month));
                qtrData[1] = tempData.filter(data => h[1].includes(data.month));
            } else if (breakUp === 'a') {
                breakupName = 'Yearly';
                let y = [`${year}-01`, `${year}-02`, `${year}-03`, `${year}-04`, `${year}-05`, `${year}-06`,
                    `${year}-07`, `${year}-08`, `${year}-09`, `${year}-10`, `${year}-11`, `${year}-12`];
                qtrData[0] = tempData.filter(data => y.includes(data.month));
            }

            return qtrData.map((data, index) => {
                const revenue = (data || []).reduce((sum, item) => sum + item.revenue || 0, 0);
                const maintenance = (data || []).reduce((sum, item) => sum + item.maintenanceCost || 0, 0);
                const idealDays = (data || []).reduce((sum, item) => sum + item.idealDays || 0, 0);
                const ebit = Number(revenue) - Number(maintenance);
                const market = data.marketValue || 0;
                const roi = Number(market) === 0 ? 0 : Number(ebit) / Number(market);
                const opsDay = moment().diff(data.leasingDate ? moment(data.leasingDate) : moment(), 'days');
                const annRoi = Number(opsDay) === 0 ? 0 : Number(roi / (opsDay / 365));

                const asset = tempData[0];

                const breakupFieldName = breakUp === 'a' ? year : breakUp.toUpperCase() + (index + 1) + '-' + year;

                return {
                    key: index + '-' + year,
                    id: asset._id,
                    breakupName,
                    breakupFieldName,
                    assetCode: asset.assetCode,
                    assetType: asset.assetType || '',
                    assetSubType: asset.assetSubType || '',
                    assetModel: asset.assetModel || '',
                    status: asset.status || 'NA',
                    leasingDate: asset.leasingDate || '-',
                    marketValue: asset.marketValue || 0.00,
                    maintenanceCost: maintenance,
                    revenue,
                    idealDays,
                    opsDay,
                    ebit,
                    roi,
                    annRoi,
                    unRecovered: Number(market - ebit),
                };
            })
        });
        done(qtrlyData);
    });
};
